var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-container pointer",on:{"click":_vm.launchWbet}},[_c('iframe',{staticClass:"wbet-widget pe-none",attrs:{"src":_vm.widgetUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }